import { overflowNotificationConstants } from "../actions/overflowNotification";

const defaultState = {
  show: false
};

export function overflow(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case overflowNotificationConstants.SHOW_OVERFLOW:
    return {
      show: true,
      ...payload
    };
  case overflowNotificationConstants.HIDE_OVERFLOW:
    return defaultState;
  default:
    return defaultS;
  }
}
